<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('student_reports')" :isFilter="false"/>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('student_reports')" :isFilter="false"/>
            </template>
            <h6>{{ $t('select_report_type') }}</h6>
            <div class="border rounded p-5 mb-3">
                <multiselect
                    :clear-on-select="true"
                    :close-on-select="true"
                    :deselect-label="''"
                    :options="computeReportTypes"
                    :placeholder="$t('select')"
                    :select-label="''"
                    :selected-label="''"
                    label="text"
                    track-by="value"
                    v-model="reportType"
                />
            </div>
            <div class="col-12" v-if="reportType">
                <h6>
                    <span v-if="reportType && reportType.text">
                        {{ reportType.text }}
                    </span>
                </h6>
                <div class="border rounded p-5">
                    <component v-if="reportType && reportType.value" :is="reportType.value"/>
                </div>
            </div>
        </app-layout>
    </div>
</template>

<script>
// Template
import AppLayout from '@/layouts/AppLayout.vue'
import Header from '@/layouts/AppLayout/Header.vue'
import HeaderMobile from '@/layouts/AppLayout/HeaderMobile.vue'
// Data
import ReportTypes from '../data/StudentReportTypes'
// Pages
import undergraduateTransferYokReport from "@/modules/reports/pages/student/undergraduateTransferYokReport/Index.vue"
import facultyComparisonReport from './facultyComparisonReport/Index.vue'
import candidateSurveyCountReport from './candidateSurveyCountReport/Index.vue'
import candidateFirstChoiceSurveyCountReport from './candidateFirstChoiceSurveyCountReport/Index.vue'

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,
        undergraduateTransferYokReport,
        facultyComparisonReport,
        candidateSurveyCountReport,
        candidateFirstChoiceSurveyCountReport,
    },
    metaInfo() {
        return {
            title: this.$t('student_reports')
        }
    },
    data() {
        return {
            reportType: null
        }
    },
    computed: {
        computeReportTypes() {
            return ReportTypes().filter((item) => {
                return this.checkPermission(item.permission)
            })
        }
    }
}
</script>
